export default __webpack_public_path__ + "static/media/bar-aetr.d0acb4a7.svg";